import React from 'react';
import Element, { CommonProps } from '../Element/Element';
import { CreateProps } from '../../types/utils/CreateProps';

export type DefaultLinkAdapterProps = CreateProps<
  {
    /** link path */
    to?: string;
    /** set link to open in new window */
    openInNewWindow?: boolean;
    /** removes the attribute rel="noopener noreferrer"  */
    removeRelAttribute?: boolean;
  },
  CommonProps<'a'>,
  'tagName'
>;

const DefaultLinkAdapter: React.FunctionComponent<DefaultLinkAdapterProps> = ({
  to,
  children,
  openInNewWindow = false,
  removeRelAttribute = false,
  ...props
}) => {
  if (removeRelAttribute) {
    return (
      <Element
        {...props}
        href={to}
        target={openInNewWindow ? '_blank' : undefined}
        tabIndex={0}
        tagName="a"
      >
        {children}
      </Element>
    );
  } else {
    return (
      <Element
        {...props}
        href={to}
        target={openInNewWindow ? '_blank' : undefined}
        rel="noopener noreferrer"
        tabIndex={0}
        tagName="a"
      >
        {children}
      </Element>
    );
  }
};

export default DefaultLinkAdapter;
